import { render, staticRenderFns } from "./dati.vue?vue&type=template&id=420510fe&scoped=true&"
import script from "./dati.vue?vue&type=script&lang=js&"
export * from "./dati.vue?vue&type=script&lang=js&"
import style0 from "./dati.vue?vue&type=style&index=0&id=420510fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420510fe",
  null
  
)

export default component.exports